<template>
  <div class="quote__list-insured">
    <div class="quote__accordion">
      <BaseAccordion :alwaysDisplay="alwaysDisplay">
        <template v-slot:name>
          {{ title }}
        </template>
        <template v-slot:content>
          <ul class="quote__policy-list">
            <div v-if="editable" class="quote__edit" @click="openEditForm"></div>
            <li v-if="plateNumber_ && !disablePlateNumber">
                <div class="quote__policy-name">{{$t('qic_quote_motor_info_plate_number')}}</div>
                <div class="quote__policy-value">{{ plateNumber_ }}</div>
            </li>
            <li v-if="carShape_ && carShape_.id && carShape_.name">
              <div class="quote__policy-name">{{ $t('quote_car_info_shape') }}</div>
              <div class="quote__policy-value">{{ carShape_ && carShape_.name }}</div>
            </li>
            <li v-if="plateType_ && plateType_.id && plateType_.name && !disablePlateType">
                <div class="quote__policy-name">{{$t('qic_quote_motor_info_plate_type')}}</div>
                <div class="quote__policy-value">{{ plateType_ && plateType_.name }}</div>
            </li>
          </ul>
        </template>
      </BaseAccordion>
    </div>
    <base-popup-wrapper @close="closeEditForm" v-if="editFormShown">
      <div class="modal_titleForm">{{ $t('qic_popup_update_info') }}</div>
      <div class="inputList">
        <base-input
          v-if="!disablePlateNumber"
          :validation="$v.carInfo.plateNumber"
          :placeholder="$t('qic_quote_motor_info_plate_number')"
          @blur="trackPlateType"
          :mask="'#'.repeat(6)"
          v-model="carInfo.plateNumber">
        </base-input>
        <base-select
          style="z-index: 6;"
          v-model="carInfo.shape.id"
          :options="carShapes"
          :error="$v.carInfo.shape.$dirty && $v.carInfo.shape.$invalid"
          :caret="true"
          name="shape"
          select-key="code"
          :searchable="true"
          clearSearchButton
          :select-label="locale === 'ar' ? 'descAr' : 'desc'"
          :placeholder="$t('quote_car_info_shape')">
        </base-select>
        <base-select
          v-if="!disablePlateType"
          style="z-index: 5;"
          v-model="carInfo.type.id"
          :options="plateTypes"
          :error="$v.carInfo.type.$dirty && $v.carInfo.type.$invalid"
          :caret="true"
          name="type"
          select-key="code"
          @input="trackChooseVehicleType"
          :select-label="locale === 'ar' ? 'descAr' : 'desc'"
          :placeholder="$t('qic_quote_motor_info_plate_type')">
        </base-select>
      </div>
      <template v-slot:button>
        <base-button symbol="no" class="btn-second_medium" @click="onEdit">
          {{ $t('qic_save_and_close') }}
        </base-button>
      </template>
    </base-popup-wrapper>
  </div>
</template>

<script>
import { BaseAccordion, BaseSelect, BaseInput, BasePopupWrapper } from 'qic-components'
import { trackEvent, trackGtag } from '@/utils/useGtag'
import { required, maxLength, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'RenewMotorInfo',
  props: {
    title: { type: String, default: 'No title' },
    plateNumber: {},
    plateType: {},
    plateTypes: {},
    carShape: {},
    carShapes: {},
    editable: { type: Boolean, default: false },
    alwaysDisplay: { type: Boolean, default: false },
    disablePlateNumber: { type: Boolean, default: false },
    disablePlateType: { type: Boolean, default: false }
  },
  emits: ['edit'],
  components: {
    BaseAccordion,
    BaseSelect,
    BaseInput,
    BasePopupWrapper
  },
  data () {
    return {
      carInfo: {},
      editFormShown: false,
      locale: this.$i18n.locale
    }
  },
  computed: {
    plateType_ () {
      return {
        id: this.plateType?.id,
        name: this.plateType?.name
      }
    },
    plateNumber_ () {
      return this.plateNumber
    },
    carShape_ () {
      return {
        id: this.carShape?.id,
        name: this.carShape?.name
      }
    }
  },
  methods: {
    trackError (errorText) {
      trackGtag('input_error', { label: errorText })
    },
    trackPlateType () {
      const plateNumber = this.carInfo.plateNumber
      const numberOfSymbols = plateNumber.length
      trackEvent('typePlate', numberOfSymbols.toString())
    },
    trackChooseVehicleType () {
      const selectedType = this.carInfo.type.id
      const position = this.plateTypes.findIndex(type => type.id === selectedType) + 1
      const responseAmount = this.plateTypes.length
      trackEvent('chooseVehicleType', selectedType, {
        position: position.toString(),
        response_amount: responseAmount.toString()
      })
    },
    openEditForm () {
      trackEvent('openEditCar')
      this.carInfo = {
        type: {
          id: this.plateType_.id,
          name: this.plateType_.name
        },
        shape: {
          id: this.carShape.id,
          name: this.carShape.name
        },
        plateNumber: this.plateNumber_
      }
      this.editFormShown = true
      const body = document.querySelector('body')
      body.classList.add('overflow-off')
    },
    closeEditForm () {
      this.editFormShown = false
      const body = document.querySelector('body')
      body.classList.remove('overflow-off')
    },
    onEdit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.trackError('Fill the field')
        return
      }
      this.closeEditForm()
      this.$emit('edit', this.carInfo)
    }
  },
  beforeDestroy () {
    const body = document.querySelector('body')
    body.classList.remove('overflow-off')
  },
  validations () {
    const plateNumberValidation = {
      required,
      maxLength: maxLength(6),
      numeric
    }
    const plateNumber = this.disablePlateNumber ? {} : plateNumberValidation
    return {
      carInfo: {
        type: {
          id: {
            required
          }
        },
        shape: {
          id: {
            required
          }
        },
        plateNumber
      }
    }
  }
}
</script>
